<template>
  <div class="row">
    <div class="col-12">
      <enterprise-edit-recruitment-orientation
        ref="spreadsheet"
        @slots:changed="updateRecruitmentOrientationSubtotal"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { recruitmentOrientationsValidations } from './enrollment-process-validations'
import EnterpriseEditRecruitmentOrientation from '../common/EnterpriseEditRecruitmentOrientation'

export default {
  name: 'EnrollmentProcessRecruitmentOrientation',
  components: {
    EnterpriseEditRecruitmentOrientation
  },
  mixins: [validationMixin],
  data () {
    return {
      currentOrientationData: {}
    }
  },
  validations: recruitmentOrientationsValidations,
  methods: {
    ...mapActions('pages/enterprises', [
      'updateOrder'
    ]),
    reset () {
      this.$refs.spreadsheet.resetTimeSlots()
    },
    updateRecruitmentOrientationSubtotal (recruitmentOrientations) {
      this.currentOrientationData = Object.assign({}, this.currentOrientationData, recruitmentOrientations)
    },
    saveToStore () {
      this.updateOrder({
        recruitmentOrientations: this.currentOrientationData
      })
    }
  }
}
</script>
